'use client';
import styled, { css } from 'styled-components';

export const StyledConfirmationOrderSummary = styled.div`
  background: ${props => props.theme.colors.background.lightest};
  border-radius: ${props => props.theme.spacing(7)};
  padding: ${props => props.theme.spacing(5, 4)};
  ${props => props.theme.typography.body}

  @media ${props => props.theme.tablet} {
    border-radius: ${props => props.theme.spacing(8)};
    padding: ${props => props.theme.spacing(12, 14)};
    max-width: 900px;
  }
`;

export const OrderSummaryTitle = styled.h1`
  ${props => props.theme.typography.heading2};
  text-align: center;
  margin-bottom: ${props => props.theme.spacing(2)};
`;

export const OngoingSubscriptionTitle = styled.h1`
  ${props => props.theme.typography.heading2};
  margin-top: ${({ theme }) => theme.spacing(8)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  text-align: center;

  @media ${({ theme }) => theme.tablet} {
    margin-top: ${({ theme }) => theme.spacing(20)};
    margin-bottom: ${({ theme }) => theme.spacing(2)};
  }
`;

export const Section = styled.div`
  margin-top: ${props => props.theme.spacing(8)};
  padding-bottom: ${props => props.theme.spacing(8)};
  border-bottom: 1px solid
    ${({ theme }) => theme.colors.withAlpha('border.fur', 0.5)};

  &:last-of-type {
    border: none;
    padding-bottom: 0;
  }

  ${({ hideBorderBottom, theme }) =>
    hideBorderBottom
      ? css`
          border-bottom: none;
        `
      : css`
          border-bottom: 1px solid ${theme.colors.border.fur};
        `}

  ${({ smallMarginPadding, theme }) =>
    smallMarginPadding &&
    css`
      margin-top: ${theme.spacing(1)};
      padding-bottom: ${theme.spacing(1)};
    `}

  ${({ firstMarginTop, theme }) =>
    firstMarginTop &&
    css`
      margin-top: ${theme.spacing(8)};
    `}

  ${({ lastPaddingBottom, theme }) =>
    lastPaddingBottom &&
    css`
      padding-bottom: ${theme.spacing(8)};
    `}

  ${({ columns, mobileStacked }) =>
    columns === 2 &&
    css`
      display: flex;
      justify-content: space-between;
      flex-direction: ${mobileStacked ? 'column' : 'row'};

      @media ${({ theme }) => theme.tabletL} {
        flex-direction: row;
      }
    `}

  ${({ columns }) =>
    columns === 3 &&
    css`
      display: flex;
      flex-direction: column;

      @media ${({ theme }) => theme.tabletL} {
        justify-content: space-between;
        flex-direction: row;
      }
    `}
`;

export const SubsectionColumn = styled.div`
  flex: 1;

  &:first-of-type {
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.withAlpha('border.fur', 0.5)};
    padding-bottom: ${({ theme }) => theme.spacing(8)};

    @media ${({ theme }) => theme.tabletL} {
      border-bottom: none;
      padding-bottom: 0;
      border-right: ${({ left, theme }) =>
        left && `1px solid ${theme.colors.withAlpha('border.fur', 0.5)}`};
    }
  }

  &:last-of-type {
    padding-top: ${({ theme }) => theme.spacing(8)};

    @media ${({ theme }) => theme.tabletL} {
      padding-top: 0;
    }
  }
`;

export const ExpectedDeliveryWrapper = styled.div`
  margin-left: ${props => props.theme.spacing(0)};

  @media ${({ theme }) => theme.tabletL} {
    margin-left: ${props => props.theme.spacing(14)};
  }
`;

export const SectionTitle = styled.h4`
  position: relative;
  ${({ theme }) => theme.typography.heading4}
  font-weight: bold;
  color: ${props => props.theme.colors.text.secondary};
`;

export const SectionSubtitle = styled.h4`
  color: ${props =>
    props.color
      ? props.theme.colors.get(props.color, props.theme.colors.text.primary)
      : props.theme.colors.text.secondary};
  ${props =>
    props.value
      ? props.theme.typography.bodyBold
      : props.theme.typography.body};
  ${props => (props.heading ? props.theme.typography.subheading2 : null)}
`;

export const SectionBody = styled.p`
  ${({ theme }) => theme.typography.body};
  color: ${props => props.theme.colors.text.secondary};
`;

export const PaymentMethodInfo = styled.span`
  height: 100%;
  display: flex;
  align-items: center;
  margin-top: ${props => props.theme.spacing(3)};
  gap: ${props => props.theme.spacing(4)};
`;
